<template>
  <div class="ModuleNav">
	  <el-scrollbar>
		  <el-menu
			:default-active="DefaultActivePath"
			@open="handleOpen"
			@close="handleClose"
			@select="handSelect"
			:unique-opened="true"
		>
		<div class="ModuleNavBody">
			<el-menu-item index="/Home">
				<!-- <el-icon><Histogram /></el-icon> -->
				<span>平台数据</span>
			</el-menu-item>
			<template v-for="MenuData in MenuJsonData">
				<!-- 一级菜单 -->
				<el-menu-item :index="MenuData.Path" v-if="MenuData.Children.length == 0">
					<el-icon v-if="MenuData.Icon"><component :is="MenuData.Icon"></component></el-icon>
					<span>{{MenuData.Title}}</span>
				</el-menu-item>
				<!-- 二级菜单 -->
				<el-sub-menu :index="MenuData.Path" v-if="MenuData.Children.length >= 1">
					<template #title>
						<el-icon v-if="MenuData.Icon"><component :is="MenuData.Icon"></component></el-icon>
						<span>{{MenuData.Title}}</span>
					</template>
					<template v-for="MenuChildrenData in MenuData.Children">
						<el-menu-item :index="MenuChildrenData.Path" v-if="MenuChildrenData.Children.length == 0">
							<el-icon v-if="MenuChildrenData.Icon"><component :is="MenuChildrenData.Icon"></component></el-icon>
							<span>{{MenuChildrenData.Title}}</span>
						</el-menu-item>
						<!-- 三级菜单 -->
						<el-sub-menu :index="MenuChildrenData.Path" v-if="MenuChildrenData.Children.length >= 1">
							<template #title>
								<el-icon v-if="MenuChildrenData.Icon"><component :is="MenuChildrenData.Icon"></component></el-icon>
								<span>{{MenuChildrenData.Title}}</span>
							</template>
							<template v-for="MenuChildrenChildrenData in MenuChildrenData.Children">
								<el-menu-item :index="MenuChildrenChildrenData.Path">
									<el-icon><component :is="MenuChildrenChildrenData.Icon"></component></el-icon>
									<span>{{MenuChildrenChildrenData.Title}}</span>
								</el-menu-item>
							</template>
						</el-sub-menu>
					</template>
				</el-sub-menu>
			</template>
			</div>
		</el-menu>
	  </el-scrollbar>
  </div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>